import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import AppLoadingScreen from '@components/AppLoadingScreen';

type AuthStatus = 'checking' | 'allowed' | 'denied';

type PropsType = {
  children: React.ReactNode;
  user?: unknown;
};

function readSessionUser(): { phoneNumber?: string } {
  try {
    return JSON.parse(localStorage.getItem('userData') || '{}');
  } catch {
    return {};
  }
}

const ProtectedRoute = ({ user: _user, children }: PropsType) => {
  const [status, setStatus] = useState<AuthStatus>('checking');

  useEffect(() => {
    const userData = readSessionUser();
    setStatus(userData?.phoneNumber ? 'allowed' : 'denied');
  }, []);

  if (status === 'checking') {
    return (
      <AppLoadingScreen
        variant="fullscreen"
        context="auth"
      />
    );
  }

  if (status === 'denied') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
